import parkRoutes from './routes'

/* @ngInject */
const parkRun = (
  $transitions,
  storageHandler,
  $$wagon,
  $$train,
  $$railway,
  maneuverMenu,
) => {
  $transitions.onSuccess({
    entering: parkRoutes.index.path,
  }, (trans) => {
    maneuverMenu.radio.value = 'parkMenu'

    if (storageHandler.get('maneuver.park.myTrain')) {
      $$train.data.myTrain = storageHandler.get('maneuver.park.myTrain')
    } else {
      $$train.data.myTrain = $$train.new.classic()
    }

    if (storageHandler.get('maneuver.park.myWagon')) {
      $$wagon.data.myWagon = storageHandler.get('maneuver.park.myWagon')
    } else {
      $$wagon.data.myWagon = $$wagon.new.classic()
    }

    if (storageHandler.get('maneuver.park.myWagonIds')) {
      $$wagon.data.myWagonIds = storageHandler.get('maneuver.park.myWagonIds')
    } else {
      $$wagon.data.myWagonIds.splice(0, $$wagon.data.myWagonIds.length)
    }

    if (storageHandler.get('maneuver.park.myRailway')) {
      $$railway.data.myRailway = storageHandler.get('maneuver.park.myRailway')
    } else {
      $$railway.data.myRailway = null
    }
  })

  $transitions.onBefore({
    from: parkRoutes.index.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('maneuver.park.myTrain', $$train.data.myTrain)
      storageHandler.save('maneuver.park.myWagon', $$wagon.data.myWagon)
      storageHandler.save('maneuver.park.myWagonIds', $$wagon.data.myWagonIds)
      storageHandler.save('maneuver.park.myRailway', $$railway.data.myRailway)

      $$train.data.myTrain = null
      $$wagon.data.myWagon = null
      $$wagon.data.myWagonIds.splice(0, $$wagon.data.myWagonIds.length)
      $$railway.data.myRailway = null
    }
  })
}

export default parkRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/park/park.run.js